<template>
  <div class="p15 bacf borr10">
    <div class="clearfix">
      <span class="fl fontw font16">最新更新</span>
      <span class="fr c99 curp" @click="changeNews"
        ><i class="iconfont">&#xe678;</i>换一换</span
      >
    </div>
    <div v-for="(item, index) in newList" :key="index" class="mt10">
      <p class="overh newTitle curp" @click="detail(item.guid)">
        {{ item.questiontitle }}
      </p>
      <div class="mt10 clearfix">
        <span class="fl c99">{{ item.commentamount }}人参与互动</span>
        <span class="fr c99">{{ item.fbdate.split(" ")[0] }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newList: [],
      pageIndex: 1,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      var that = this;
      this.loading = true;
      this.$get(
        `${this.$store.state.api.webUrl}/question/recentlyList.json`,
        {
          pageIndex: this.pageIndex,
          pageSize: 3,
        },
        (data) => {
          that.total = data.total;
          that.newList = data.rows;
        }
      );
    },
    //换一换
    changeNews() {
      if (this.pageIndex < this.total / 3) {
        this.pageIndex++;
      } else {
        this.pageIndex = 1;
      }
      this.getList();
    },
    detail(guid) {
      this.$router.push({
        path: "/everydayQuestion/questionInfo?guid=" + guid,
      });
    },
  },
};
</script>

<style scoped>
.newTitle:hover {
  color: #409eff;
}
</style>
